/* TI-GEEK front-end: hero carousel · drawer · reveal · FAQ · PDP gallery/qty */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* ---- mobile drawer ---- */
  document.querySelectorAll('[data-tgk-burger]').forEach(function (b) {
    b.addEventListener('click', function () { document.querySelector('.tigeek-drawer').classList.add('open'); });
  });
  document.querySelectorAll('[data-tgk-close]').forEach(function (b) {
    b.addEventListener('click', function () { document.querySelector('.tigeek-drawer').classList.remove('open'); });
  });
  var drawer = document.querySelector('.tigeek-drawer');
  if (drawer) drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { drawer.classList.remove('open'); }); });

  /* ---- hero carousel ---- */
  document.querySelectorAll('[data-tgk-hero]').forEach(function (hero) {
    var slides = [].slice.call(hero.querySelectorAll('.slide'));
    var dots = [].slice.call(hero.querySelectorAll('.dot'));
    if (slides.length < 2) return;
    var cur = 0, timer = null, delay = parseInt(hero.getAttribute('data-autoplay'), 10) || 0;
    function show(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('on', n === cur); });
      dots.forEach(function (d, n) { d.classList.toggle('on', n === cur); });
    }
    function start() { if (!reduce && delay > 0) timer = setInterval(function () { show(cur + 1); }, delay); }
    function reset() { clearInterval(timer); start(); }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { show(n); reset(); }); });
    var prev = hero.querySelector('.arrow.l'), next = hero.querySelector('.arrow.r');
    if (prev) prev.addEventListener('click', function () { show(cur - 1); reset(); });
    if (next) next.addEventListener('click', function () { show(cur + 1); reset(); });
    start();
  });

  /* ---- reveal on scroll ---- */
  var reveals = document.querySelectorAll('.tigeek .reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    reveals.forEach(function (el) { io.observe(el); });
  } else { reveals.forEach(function (el) { el.classList.add('in'); }); }

  /* ---- FAQ accordion (PDP) ---- */
  document.querySelectorAll('.tigeek [data-tgk-faq] button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var qa = btn.parentElement, ans = qa.querySelector('.ans'), open = qa.classList.contains('open');
      qa.parentElement.querySelectorAll('.qa').forEach(function (x) { x.classList.remove('open'); var a = x.querySelector('.ans'); if (a) a.style.maxHeight = null; });
      if (!open) { qa.classList.add('open'); if (ans) ans.style.maxHeight = ans.scrollHeight + 'px'; }
    });
  });

  /* ---- PDP gallery thumbs ---- */
  document.querySelectorAll('[data-tgk-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-tgk-main]');
    g.querySelectorAll('[data-tgk-thumb]').forEach(function (th) {
      th.addEventListener('click', function () {
        if (main) main.src = th.getAttribute('data-full') || th.querySelector('img').src;
        g.querySelectorAll('[data-tgk-thumb]').forEach(function (t) { t.classList.remove('on'); });
        th.classList.add('on');
      });
    });
  });

  /* ---- PDP quantity ---- */
  document.querySelectorAll('[data-tgk-qty]').forEach(function (q) {
    var input = q.querySelector('input, [data-tgk-qval]');
    var get = function () { return parseInt((input.value || input.textContent), 10) || 1; };
    var set = function (n) { n = Math.max(1, n); if ('value' in input) input.value = n; else input.textContent = n; };
    var d = q.querySelector('[data-tgk-minus]'), p = q.querySelector('[data-tgk-plus]');
    if (d) d.addEventListener('click', function () { set(get() - 1); });
    if (p) p.addEventListener('click', function () { set(get() + 1); });
  });

  /* ---- PDP variant picker (maps options -> variant id/price/availability) ---- */
  document.querySelectorAll('[data-tgk-buybox]').forEach(function (box) {
    var dataEl = box.querySelector('[data-tgk-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = box.querySelector('[data-tgk-id]');
    var priceEl = box.querySelector('[data-tgk-price]');
    var atc = box.querySelector('[name=add]');
    var matcPrice = document.querySelector('.tigeek-matc .mp');
    var main = box.closest('.tigeek-pdp-wrap') && box.closest('.tigeek-pdp-wrap').querySelector('[data-tgk-main]');
    function money(c) { return '$' + (c / 100).toFixed(2); }
    function update() {
      var sel = [];
      box.querySelectorAll('[data-tgk-opt]:checked').forEach(function (r) { sel[parseInt(r.getAttribute('data-tgk-opt'), 10) - 1] = r.value; });
      var v = null;
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < sel.length; j++) { if (variants[i].options[j] !== sel[j]) { ok = false; break; } }
        if (ok) { v = variants[i]; break; }
      }
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (matcPrice) matcPrice.textContent = money(v.price);
      if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? 'Add to Cart' : 'Sold Out'; }
      if (main && v.featured_image && v.featured_image.src) { main.src = v.featured_image.src; }
    }
    box.querySelectorAll('[data-tgk-opt]').forEach(function (r) { r.addEventListener('change', update); });
  });
})();
